import useMarkProposalAsDeclined from '@/api/mutations/proposals/useMarkProposalAsDeclined';
import ProposalConfirmationModal from '@/ui/pages/proposalBuilderPage/components/proposalLifecycleActions/ProposalConfirmationModal';
import { ModalProps, Text, useToastContext } from '@payaca/ambrosia';
import { FC } from 'react';

type MarkProposalAsDeclinedModalProps = {
  proposalId: string;
  projectId: string;
} & Omit<ModalProps, 'title'>;

const MarkProposalAsDeclinedModal: FC<MarkProposalAsDeclinedModalProps> = (
  props
) => {
  const { proposalId, projectId, onClose, ...rest } = props;
  const { pushSuccess } = useToastContext();

  const { mutate, isPending } = useMarkProposalAsDeclined({
    proposalId,
    projectId,
    options: {
      onSuccess: () => {
        pushSuccess('Proposal marked as declined.');
        onClose?.();
      },
    },
  });

  return (
    <ProposalConfirmationModal
      {...rest}
      onClose={onClose}
      title="Mark as declined"
      confirmLabel="Mark as declined"
      isPending={isPending}
      onConfirm={() => mutate({ id: proposalId })}
    >
      <Text>
        This records the customer&apos;s decision without asking them, and runs
        your decline automations. You cannot mark it as accepted afterwards.
        Only the customer can accept a proposal they declined.
      </Text>
    </ProposalConfirmationModal>
  );
};

export default MarkProposalAsDeclinedModal;
